module.exports = __webpack_public_path__ + "img/draw.7f9de6aa.png";